<ng-container *transloco="let t; read: 'partials.headline'">
  <div *ngIf="ac" class="headline" role="region" aria-label="Kopfbereich">
    <div class="p-grid">
      <div class="no-wrap p-col-4">
        <span class="line-right">{{ ac.name }}</span><span *ngIf="clock !== null" class="line-right"><i class="p-d-none p-d-lg-inline">{{ clock | amDateFormat: 'DD.MM.YYYY' }} - </i>{{ clock | amDateFormat: 'HH:mm:ss' }}</span>
      </div>
      <div class="p-col-4 p-text-center">
        <div class="network-error" *ngIf="(data.networkError$ | async) === true">
          <span><i class="pi pi-exclamation-triangle"></i> {{ t('messages.network_error') }}</span>
        </div>
      </div>
      <div class="p-text-right no-wrap p-col-4" role="region" aria-label="{{ t('user_infos') }}">
        <span class="line-left">
          <a routerLink="/dashboard" role="link">
            <i class="p-d-none p-d-lg-inline">{{ t('agenda') }} </i>
            <fa-icon [icon]="faHome"></fa-icon>
          </a>
        </span>
        <span class="line-left">
          <a routerLink="/ac/notices" role="link">
            <i class="p-d-none p-d-lg-inline">{{ t('notices') }} </i>
            <fa-icon [icon]="faEdit"></fa-icon>
          </a>
        </span>
        <span class="line-left">
          <a *ngIf="isFullScreen() !== true" (click)="openFullScreen()" (keyup.enter)="openFullScreen()" role="link" tabindex="0">
            <i class="p-d-none p-d-lg-inline">{{ t('fullscreen') }} </i>
            <fa-icon [icon]="faExpandWide"></fa-icon>
          </a>
          <a *ngIf="isFullScreen() === true" (click)="closeFullScreen()" (keyup.enter)="closeFullScreen()" role="link" tabindex="0">
            <i class="p-d-none p-d-lg-inline">{{ t('fullscreen') }} </i>
            <fa-icon [icon]="faCompressWide" class="pointer"></fa-icon>
          </a>
        </span>
        <span class="line-left">
          <a (click)="menu.toggle($event)" (keyup.enter)="menu.toggle($event)" role="link" tabindex="0">
            <fa-icon [icon]="faUser"></fa-icon>
          </a>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </span>
      </div>
    </div>
  </div>

  <p-dialog [(visible)]="changeProcedureVisible" *ngIf="auth.isModerator()" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '80vw', maxWidth: '80vw'}">
    <ng-template pTemplate="header">
      <h2>{{ t('change_ac') }}</h2>
    </ng-template>
    <app-ac-selector [acs]="changeProcedureAcList" [mode]="AcSelectorModes.Change" [loading]="changeProcedureLoading" (selected)="selectAc($event)" (cancelled)="hideChangeAc($event)"></app-ac-selector>
  </p-dialog>

</ng-container>

